<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <p v-for="route in permission_routes" :key="route.path">
          <sidebar-item :item="route" :base-path="route.path" />
        </p>
      </el-menu>
    </el-scrollbar>

    <div class="admin-info">
      <div class="info">
        <p>Role: {{ this.$store.state.user.roles[0] }}</p>
        <p>Version: {{ version }}</p>
      </div>
      <div class="logo">
        <svg-icon class="sidebar-logo" icon-class="logo" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.scss";
import { getVersion } from "@/api/uvm/index";

export default {
  components: { SidebarItem, Logo },
  data() {
    return {
      version: "",
    };
  },
  created() {
    getVersion().then((res) => {
      // cosnoel.log(res.data.version)
      this.version = res.data.version;
    });
  },
  mounted() {
    console.log(this.permission_routes);
  },
  computed: {
    ...mapGetters(["permission_routes", "sidebar"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
};
</script>
<style lang="scss" scoped>
.admin-info {
  display: flex;
  padding: 0 10px;
  align-items: center;
  justify-content: center;
  .info {
    p {
      font-size: 20px;
    }
  }
  .logo {
    font-size: 70px;
  }
}
</style>
